/* eslint-disable array-callback-return */
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import sanityClient from "../Client";
import * as AiIcons from "react-icons/ai";
import Banner from "../components/Banner";
import Footer from "../components/Footer";

const Work = () => {
  const [projects, setProjects] = useState(null);
  const [isAllProjects, setIsAllProjects] = useState(false);
  const [isDesigns, setIsDesigns] = useState(false);
  const [isDevelopments, setIsDevelopments] = useState(false);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "work"] {
        title,
        slug,
        mainImage{
          asset->{
              _id,
              url
          },
          alt,
        },
        category,
        type,
        tagline,
        description,
        comingSoon,
        role,
        year,
        awards,
        link
    }`
      )
      .then((data) => {
        if (isDesigns) {
          const filteredDesigns = data?.filter((item) => {
            if (item?.category === "Design") return item;
          });
          setProjects(
            filteredDesigns?.sort((a, b) =>
              a.year < b.year ? 1 : -1 && a.title > b.title ? 1 : -1
            )
          );
        } else if (isDevelopments) {
          const filteredDevelopments = data?.filter((item) => {
            if (item?.category === "Development") return item;
          });
          setProjects(
            filteredDevelopments?.sort((a, b) =>
              a.year < b.year ? 1 : -1 && a.title > b.title ? 1 : -1
            )
          );
        } else if (isAllProjects) {
          setProjects(
            data?.sort((a, b) =>
              a.year < b.year ? 1 : -1 && a.title > b.title ? 1 : -1
            )
          );
        } else {
          setIsAllProjects(true);
          setProjects(
            data?.sort((a, b) =>
              a.year < b.year ? 1 : -1 && a.title > b.title ? 1 : -1
            )
          );
        }
      })
      .catch(console.error);
  }, [isAllProjects, isDesigns, isDevelopments]);

  return (
    <>
      <motion.div
        className="work"
        initial={{ opacity: 0, z: 100 }}
        animate={{ opacity: 1, z: 0 }}
        exit={{ opacity: 0, z: -100 }}
        transition={{ duration: 1, delay: 0.75 }}
      >
        <div className="work-heading">
          <Banner text="Work" />
        </div>
        <div className="work-filter">
          <div className="work-filter-btn-container">
            <button
              className={isAllProjects ? "work-btn is-Active" : "work-btn"}
              onClick={() => {
                setIsAllProjects(true);
                setIsDesigns(false);
                setIsDevelopments(false);
              }}
            >
              All
            </button>
            <button
              className={isDesigns ? "work-btn is-Active" : "work-btn"}
              onClick={() => {
                setIsDesigns(true);
                setIsAllProjects(false);
                setIsDevelopments(false);
              }}
            >
              Design
            </button>
            <button
              className={isDevelopments ? "work-btn is-Active" : "work-btn"}
              onClick={() => {
                setIsDevelopments(true);
                setIsAllProjects(false);
                setIsDesigns(false);
              }}
            >
              Development
            </button>
          </div>
        </div>
        <div className="divider" />
        <div className="work-container">
          {projects?.map((item, index) => (
            <Link
              to={"/work/" + item.slug.current}
              key={index}
              className="work-item"
            >
              <div
                className="work-item-img-container"
                style={{
                  backgroundImage: `url(${item.mainImage?.asset.url})`,
                }}
              >
                <div className="work-item-btn-container">
                  <div>
                    <AiIcons.AiOutlinePlus />
                  </div>
                </div>
              </div>
              <div className="work-item-text-container">
                <div className="work-item-text">
                  <h3 className="work-item-title">{item.title}</h3>
                  <p className="work-item-role">{item.role}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </motion.div>
      <motion.div
        className="page-bottom-sections"
        initial={{
          opacity: 0.75,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        }}
        whileInView={{
          opacity: 1,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
        }}
        transition={{ duration: 0.5 }}
      >
        <Footer />
      </motion.div>
    </>
  );
};

export default Work;
